import { EntityType } from '@frontend/common';

import { attributeReactiveDetail } from '../../attribute/modal/attribute.reactive-detail';
import { certificateReactiveDetail } from '../../certificate/modal/certificate.reactive-detail';
import { colliReactiveDetail } from '../../colli/modal/colli.reactive-detail';
import { constraintReactiveDetail } from '../../constraint/modal/constraint.reactive-detail';
import { deceasedReactiveDetail } from '../../deceased/modal/deceased.reactive-detail';
import { equipmentReactiveDetail } from '../../equipment/modal/equipment.reactive-detail';
import { iotReactiveDetail } from '../../iot/modal/iot.reactive-detail';
import { moduleReactiveDetail } from '../../module/modal/module.reactive-detail';
import { notificationReactiveDetail } from '../../notification/modal/notification.reactive-detail';
import { orderReactiveDetail } from '../../order/modal/order.reactive-detail';
import { productCategoryReactiveDetail } from '../../product-category/modal/product-category.reactive-detail';
import { productReactiveDetail } from '../../product/modal/product.reactive-detail';
import { reportReactiveDetail } from '../../report/modal/report.reactive-detail';
import { reviewReactiveDetail } from '../../review/modal/review.reactive-detail';
import { roleReactiveDetail } from '../../role/modal/role.reactive-detail';
import { scheduleReactiveDetail } from '../../schedule/modal/schedule.reactive-detail';
import { slotReactiveDetail } from '../../slot/modal/slot.reactive-detail';
import { spotReactiveDetail } from '../../spot/modal/spot.reactive-detail';
import { transactionReactiveDetail } from '../../transaction/modal/transaction.reactive-detail';
import { userGroupReactiveDetail } from '../../user-group/modal/user-group.reactive-detail';
import { userReactiveDetail } from '../../user/modal/user.reactive-detail';
import { AnyReactiveDetailRegistryEntry } from './reactive-detail.types';

/** Entity types that open in ReactiveDetailShell. Each entry lives next to its domain (`{domain}/modal/*.reactive-detail.tsx`). */
const registryByType: Partial<Record<EntityType, AnyReactiveDetailRegistryEntry>> = {
    [EntityType.SPOT]: spotReactiveDetail,
    [EntityType.SLOT]: slotReactiveDetail,
    [EntityType.MODULE]: moduleReactiveDetail,
    [EntityType.USER]: userReactiveDetail,
    [EntityType.USER_GROUP]: userGroupReactiveDetail,
    [EntityType.ROLE]: roleReactiveDetail,
    [EntityType.TRANSACTION]: transactionReactiveDetail,
    [EntityType.COLLI]: colliReactiveDetail,
    [EntityType.PRODUCT]: productReactiveDetail,
    [EntityType.PRODUCT_CATEGORY]: productCategoryReactiveDetail,
    [EntityType.ATTRIBUTE]: attributeReactiveDetail,
    [EntityType.EQUIPMENT]: equipmentReactiveDetail,
    [EntityType.IOT]: iotReactiveDetail,
    [EntityType.CONSTRAINT]: constraintReactiveDetail,
    [EntityType.NOTIFICATION]: notificationReactiveDetail,
    [EntityType.REPORT]: reportReactiveDetail,
    [EntityType.SCHEDULE]: scheduleReactiveDetail,
    [EntityType.CERTIFICATE]: certificateReactiveDetail,
    [EntityType.ORDER]: orderReactiveDetail,
    [EntityType.REVIEW]: reviewReactiveDetail,
    [EntityType.DECEASED]: deceasedReactiveDetail
};

export function getReactiveDetailRegistryEntry(entityType: EntityType | string): AnyReactiveDetailRegistryEntry | undefined {
    return registryByType[entityType as EntityType];
}
